import { render } from "./TaxReportCustom2020.vue?vue&type=template&id=7f865550&scoped=true"
import script from "./TaxReportCustom2020.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2020.vue?vue&type=script&lang=js"

import "./TaxReportCustom2020.vue?vue&type=style&index=0&id=7f865550&scoped=true&lang=css"
import "./TaxReportCustom2020.vue?vue&type=style&index=1&id=7f865550&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f865550"]])

export default __exports__